import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import { Table, TableColumn } from "../../../components/table";
import IconMdi from "@mdi/react";
import {
  mdiPencilCircle,
  mdiPlusNetworkOutline,
  mdiDelete,
  mdiAccountGroup,
} from "@mdi/js";
import { useState, useEffect } from "react";
import EmptyModel from "../../../components/modal/emptyModal";
//import Input from "../../../components/textfield/input";
import { useHistory } from "react-router";
import axios from "axios";
import { Modal } from "antd";
import { Icon } from "@iconify/react";
import { Select, Row, Col, Alert, message, Form, Input, Checkbox } from "antd";
import {
  CheckBox,
  CheckBox2,
  RadioField,
  Textarea,
  TextBox,
} from "../../../components/textfield";

const Payments = () => {
  const { confirm } = Modal;
  const { Option } = Select;
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenCreate, setIsOpenCreate] = useState(false);
  const [isOpenCreateNext, setIsOpenCreateNext] = useState(false);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [category, setCategory] = useState<any>([]);

  const [categoryId, setCategoryId] = useState("");
  const [name, setName] = useState<string>("");
  const [code, setCode] = useState<string>("");

  const [type, setType] = useState<string>("");
  const [paymentList, setPaymentList] = useState<any>([]);
  const [paymentTypeList, setPaymentTypeList] = useState<any>([]);
  const [branches, setBranches] = useState<any>([]);
  const [banks, setBanks] = useState<any>([]);

  const [createPaymeny, setCreatePaymeny] = useState<any>({
    format: "",
    type: "",
    type_code: "",
    bankNumber: "",
    bankName: "",
    branches: [],
  });

  const [selectPaymeny, setSelectPaymeny] = useState<any>({
    _id: "",
    format: "",
    type: "",
    type_code: "",
    bankNumber: "",
    bankName: "",
    branches: [],
  });
  const columns = [
    {
      title: "",
    },
    {
      title: "ชื่อ/Name",
    },
    {
      title: "การชำระเงิน/Payment or Pay In",
      align: "center",
    },
    {
      title: "ประเภท/Type",
    },
    {
      title: "",
      align: "center",
      colspan: 4,
    },
  ];

  function onClose() {
    setIsOpen(false);
    setIsOpenCreate(false);
    setIsOpenCreateNext(false);
    setIsOpenEdit(false);
    setSelectPaymeny({});
  }

  const getData = () => {
    axios.get(`/payments`).then((res) => {
      const { data } = res;
      setPaymentList(data);
    });
  };
  const getPaymentsType = () => {
    axios.get(`/payments/type`).then((res) => {
      const { data } = res;
      setPaymentTypeList(data);
    });
  };
  const getBranches = () => {
    axios.get(`/branches`).then((res) => {
      const { data } = res;
      setBranches(data?.data);
    });
  };
  const getBanks = () => {
    axios.get(`/banks`).then((res) => {
      const { data } = res;
      setBanks(data?.data);
    });
  };


  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        axios.delete(`/payments/${id}`).then((res) => {
          let index = paymentList.findIndex((item: any) => item._id === id);
          let payment = paymentList;
          payment.splice(index, 1);
          setPaymentList([...payment]);
        });
      },
      width: "fit-content",
    });
  }

  const findType = (type: string) => {
    let index = paymentTypeList.findIndex((item: any) => item._id === type);
    return paymentTypeList[index];
  };
  const NextCreate = () => {
    if (createPaymeny.format === "") {
      message.warning("กรุณาเลือกรูปแบบการชำระเงิน!");
    } else {
      setIsOpenCreateNext(true);
    }
  };
  const isCreate = () => {
    axios.post(`/payments`, createPaymeny).then((res: any) => {
      if (res.status === 200) {
        message.success("สร้างการชำระเงินสำเร็จ/Create Payment Successfully");
        onClose();
        getData();
      }
    });
  };
  const isUpdate = () => {
    axios.patch(`/payments/${selectPaymeny?._id}`, selectPaymeny).then((res: any) => {
      if (res.status === 200) {
        onClose();
        getData();
      }
    });
  };
  useEffect(() => {
    getData();
    getPaymentsType();
    getBranches();
    getBanks();
  }, []);

  return (
    <div>
      <HeaderBar title="PAYMENT& PAY IN" />
      <EmptyModel show={isOpenEdit} onClose={onClose} width="650px">
        <h5>แก้ไขการชำระเงิน/Edit Payment</h5>
        {selectPaymeny?.type &&
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "20px 40px",
              }}
            >
              <div className="row justify-center  mt-20">
                <div
                  style={{
                    padding: 0,
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  ประเภทการชำระเงิน/Payment Type
                </div>
                <Form.Item
                  name="productCategories"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    defaultValue={selectPaymeny?.type}
                    onChange={(value: any) =>
                      setSelectPaymeny({
                        ...selectPaymeny,
                        type: value,
                      })
                    }
                    style={{ width: "100%" }}
                    filterOption={(input: any, option: any) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }

                  >
                    {paymentTypeList.map((item: any, index: any) => (
                      <Option value={item._id} key={index}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="row justify-center  mt-20">
                <label
                  style={{
                    color: "#5BAEA9",
                    marginBottom: 15,
                    fontSize: 14,
                    fontWeight: 500,
                    paddingLeft: 0,
                  }}
                >
                  ชื่อการชำระเงิน/Payment Name
                </label>
                <Input
                  value={selectPaymeny?.name}
                  onChange={(e: any) => {
                    setSelectPaymeny({ ...selectPaymeny, name: e.target.value });
                  }}
                />
              </div>
              <div className="row justify-center  mt-20">
                <div
                  style={{
                    padding: 0,
                    color: "#5BAEA9",
                    marginBottom: 5,
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  สาขาที่ใช้/Branches Used
                </div>
                <Form.Item
                  name="productCategories"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    defaultValue={selectPaymeny.branches}
                    onChange={(value: string[]) =>
                      setSelectPaymeny({
                        ...selectPaymeny,
                        branches: value,
                      })
                    }
                    style={{ width: "100%" }}
                    filterOption={(input: any, option: any) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                  >
                    {branches.map((item: any, index: any) => (
                      <Option value={item._id} key={index}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="justify-center mt-40">
                <MainButton
                  className="mg-10"
                  background="#E76464"
                  title="ยกเลิก/Cancel"
                  onClick={() => onClose()}
                />
                <MainButton
                  className="mg-10"
                  title="บันทึกข้อมูล/Submit"
                  onClick={() => isUpdate()}
                />
              </div>
            </div>
          </>
        }
      </EmptyModel>
      <EmptyModel show={isOpenCreate} onClose={onClose} width="650px">
        <h5>สร้าง/Create </h5>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >
          <div className="row justify-center  mt-20">
            เลือกการชำระเงิน/Payment or Pay In
          </div>

          <div className="row justify-center  mt-40">
            <div className="col-6">
              <RadioField
                title="การชำระเงิน/Payment "
                name="flexRadioDefault"
                id="1"
                onClick={() =>
                  setCreatePaymeny({ ...createPaymeny, format: "payment" })
                }
              />
            </div>
            <div className="col-6">
              <RadioField
                title="การรับชำระเงิน/Pay In"
                name="flexRadioDefault"
                id="1"
                onClick={() =>
                  setCreatePaymeny({ ...createPaymeny, format: "payin" })
                }
              />
            </div>
          </div>
          <div className="justify-center mt-20">
            <div className="col-6">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ปิดหน้าต่าง/Close"
                onClick={() => onClose()}
              />
            </div>
            <div className="col-6">
              <MainButton
                className="mg-10"
                title="ถัดไป/Next"
                onClick={() => NextCreate()}
              />
            </div>
          </div>
        </div>
      </EmptyModel>
      <EmptyModel show={isOpenCreateNext} onClose={onClose} width="650px">
        <h5>สร้างการชำระเงิน/Create Payment</h5>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >
          <div className="row justify-center  mt-20">
            <div
              style={{
                padding: 0,
                color: "#5BAEA9",
                marginBottom: 5,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              ประเภทการชำระเงิน/Payment Type
            </div>
            <Form.Item
              name="productCategories"
              rules={[
                {
                  required: true,
                  message: "กรุณากรอกข้อมูล!",
                },
              ]}
            >
              <Select
                onChange={(value: any) =>
                  setCreatePaymeny({
                    ...createPaymeny,
                    type: value,
                  })
                }
                style={{ width: "100%" }}
                filterOption={(input: any, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                showSearch
              >
                {paymentTypeList.map((item: any, index: any) => (
                  <Option value={item._id} key={index}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          {createPaymeny.format === "payment" ? (
            <div className="row justify-center  mt-20">
              <label
                style={{
                  color: "#5BAEA9",
                  marginBottom: 15,
                  fontSize: 14,
                  fontWeight: 500,
                  paddingLeft: 0,
                }}
              >
                ชื่อการชำระเงิน/Payment Name
              </label>
              <Input
                value={createPaymeny.name}
                onChange={(e: any) => {
                  setCreatePaymeny({ ...createPaymeny, name: e.target.value });
                }}
              />
            </div>
          ) : (
            <div className="row justify-center  mt-20">
              <label
                style={{
                  color: "#5BAEA9",
                  marginBottom: 15,
                  fontSize: 14,
                  fontWeight: 500,
                  paddingLeft: 0,
                }}
              >
                ชื่อการรับชำระเงิน/Pay In Name
              </label>
              <Input
                value={createPaymeny.name}
                onChange={(e: any) => {
                  setCreatePaymeny({ ...createPaymeny, name: e.target.value });
                }}
              />
            </div>
          )}
          {createPaymeny.format === "payin" && (
            <div className="row justify-center  mt-20">
              <label
                style={{
                  color: "#5BAEA9",
                  marginBottom: 15,
                  fontSize: 14,
                  fontWeight: 500,
                  paddingLeft: 0,
                }}
              >
                เลขทีบัญชี/Bank Number
              </label>
              <Input
                value={createPaymeny.bankNumber}
                onChange={(e: any) => {
                  setCreatePaymeny({
                    ...createPaymeny,
                    bankNumber: e.target.value,
                  });
                }}
              />
            </div>
          )}
          {createPaymeny.format === "payin" && (
            <div className="row justify-center  mt-20">
              <div
                style={{
                  padding: 0,
                  color: "#5BAEA9",
                  marginBottom: 5,
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                ชื่อธนาคาร/Bank Full Name
              </div>
              <Form.Item
                name="productCategories"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  allowClear
                  onChange={(value: string[]) =>
                    setCreatePaymeny({
                      ...createPaymeny,
                      bankName: value,
                    })
                  }
                  style={{ width: "100%" }}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {banks.map((item: any, index: any) => (
                    <Option value={item.name} key={index}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          )}
          <div className="row justify-center  mt-20">
            <div
              style={{
                padding: 0,
                color: "#5BAEA9",
                marginBottom: 5,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              สาขาที่ใช้/Branches Used
            </div>
            <Form.Item
              name="productCategories"
              rules={[
                {
                  required: true,
                  message: "กรุณากรอกข้อมูล!",
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                onChange={(value: string[]) =>
                  setCreatePaymeny({
                    ...createPaymeny,
                    branches: value,
                  })
                }
                style={{ width: "100%" }}
                filterOption={(input: any, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {branches.map((item: any, index: any) => (
                  <Option value={item._id} key={index}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <div className="justify-center mt-40">
            <MainButton
              className="mg-10"
              background="#E76464"
              title="ยกเลิก/Cancel"
              onClick={() => setIsOpenCreateNext(false)}
            />
            <MainButton
              className="mg-10"
              title="บันทึกข้อมูล/Submit"
              onClick={() => isCreate()}
            />
          </div>
        </div>
      </EmptyModel>
      <div style={{ padding: "10px 40px" }}>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <MainButton
            width="250px"
            title="Create Payment & Pay IN"
            onClick={() => {
              setIsOpenCreate(true);
            }}
          >
            <Icon
              icon="ant-design:plus-outlined"
              width="1.2rem"
              height="1.2rem"
              style={{ color: "#FFFFFF" }}
            />
          </MainButton>
        </div>
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {paymentList.map((item: any, index: number) => (
              <tr
                key={index}
                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                style={{ cursor: "pointer" }}
              >
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="25%">{item.name}</TableColumn>
                <TableColumn width="15%">{item.format_name}</TableColumn>
                <TableColumn width="3%" align="center">
                  {findType(item.type)?.name}
                </TableColumn>
                <TableColumn width="3%" align="center">
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setIsOpenEdit(true);
                      setSelectPaymeny(item);
                    }}
                  >
                    <IconMdi path={mdiPencilCircle} size="24" color="#5BAEA9" />
                  </div>
                </TableColumn>
                <TableColumn
                  width="3%"
                  align="center"
                  onClick={() => {
                    showDeleteConfirm(item._id, item.name);
                    // deleteData(item._id);
                  }}
                >
                  <IconMdi path={mdiDelete} size="30" color="#FF6760" />
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default Payments;
